import { AutoComplete, Input, Tooltip, Breadcrumb, message } from "antd";
// import { t } from "i18next";
import { ActiveIcon, InactiveIcon, AddIcon } from "../../../asset/icons";
import { EditIcon, DeleteIcon, DetailIcon, SearchIcon, CloseIconSearch, AscRed, DescGrey } from "../../../asset";
import style from "./SystemParameter.module.css";
import CustomTable from "../../../component/table/CustomTable";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import { ROUTES } from "../../../constant/routeConstant";
import axios from "axios";
import _, { transform } from "lodash";
import ModalDelete from "../../../component/modal/ModalDelete";
import Delete from "../../../component/modal/ModalDelete";
import { GROLOG_URL, GROLOG_URL_DEV } from "../../../constant/apiConstant";
import CustomPaging from "../../../component/pagination/pagination";
import moment from "moment";
import Breadcumbs from '../../../component/page-components/breadcumbs/breadcumbs';
import { useDispatch, useSelector } from "react-redux";
import { onChanged } from "../../../util/Util";

const SystemParameterList = (props) => {
  const { token, client_id, grolog_account_id, userId } = useSelector((state) => state.auth);
  let param = `CLIENT_ID=${client_id}&RESOURCE_USER_ID=${userId}&GROLOG_ACCOUNT_ID=${grolog_account_id}`;
  const { t } = useTranslation();
  const [listData, setListData] = useState([]);
  const navigate = useNavigate();
  const [showDelete, setShowDelete] = useState(false);
  const [data, setData] = useState([]);
  const [sorting, setSorting] = useState("asc");
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [initiate, setInitiate] = useState();
  const [searchRecommendation, setSearchRecommedation] = useState()
  const [listRecommendation, setListRecommendation] = useState([])
  const [filter, setFilter] =useState()
  const [load, setLoad] = useState(false)
  const [dropdown, setDropdown] = useState([]);
  const [depot, setDepot] = useState();
  const [depotName, setDepotName] = useState();
  const [depot1, setDepot1] = useState();
  const [depotName1, setDepotName1] = useState(); 
  const [isFilter, setIsfilter] = useState(false);
  const dispatch= useDispatch()
  const api = GROLOG_URL;

  const doGet = async (endpoint, tkn, params, dispatch, refresh_token) => {
    const url = api + endpoint;
    const method = "GET";
    const headers = { "Authorization": tkn };
    const request = { url, method, headers, params };
    return axios(request);
  };

  const fetchData = async (data, sort, pages) => {
    let id = 1;
    let res = await doGet(
      `/grolog-parameter?page=${pages ? pages :page}&limit=${limit}&order=id ${sort? sort :sorting}${filter ? "&filter=name||code lk " + filter: data ? "&filter=name||code lk "+ data: ""}&${param}`,
      token
    );
    let init = await doGet(
      `/grolog-parameter/initiate?page=${pages ? pages :page}&limit=${limit}&order=id ${sort? sort :sorting}${filter ? "&filter=name||code lk " + filter: data ? "&filter=name||code lk "+data:""}&${param}`,
      token
    );
    setListData(res?.data?.payload?.data);
    setInitiate(init?.data?.payload);
    console.log("dalem",init.data);
  };

  console.log("inittt",initiate);

  useEffect(() => {
    fetchData();
    onChanged(dispatch, false)
  }, [page, limit,filter]);

  const handleEdit = (id) => {
    navigate(ROUTES.PARAMETER.EDIT, { state: id });
  };

  const handleDetail = (id) => {
    navigate(ROUTES.PARAMETER.DETAIL, { state: id });
  };

  const dataSource = listData
    ? listData.map((result) => ({
        code: (
          <span className="font-roboto text-lg text-[#222222]">
            {result?.parameter_code}
          </span>
        ),

        name: (
          <span className="font-roboto text-lg text-[#222222]">
            {result?.parameter_name}
          </span>
        ),
        created_by: (
          <span className="font-roboto text-lg text-[#222222]">
            {moment.parseZone(result?.created_at).locale("id").format("DD/MM/YYYY")} | 
            
            {moment.parseZone(result?.created_at).locale("id").format("HH:mm")}
          </span>
        ),
        modified_by: (
          <span className="font-roboto text-lg text-[#222222]">
            {result?.updated_by_name ? result?.updated_by_name : "-"}
          </span>
        ),
        action: (
          <div className="flex gap-[26px]">
            <Tooltip title={t("USER:EDIT_TOOLTIP")} color="#CF0000">
              <button onClick={() => handleEdit(result?.id)}>
                <img src={EditIcon} alt="edit" />
              </button>
            </Tooltip>

            <Tooltip title={t("USER:DETAIL_TOOLTIP")} color="#CF0000">
              <button
                onClick={() => handleDetail(result?.id)}
              >
                <img src={DetailIcon} alt="det" />
              </button>
            </Tooltip>
          </div>
        ),
      }))
    : null;

    const doSort = async (sort) => {
      setSorting(sort);
    
      if (sort) {
      setSorting(sort);
        
      fetchData(data, sort);
      }
    };

  const ListColumn = [
    {
      title: (
        <div style={{ display: "flex", width: "auto" }}>
        <div>
          <span className="font-roboto text-lg text-[#222222] font-medium">
            {t("Parameter Code")}
          </span>
        </div>
        <div style={{ marginLeft: "10px", marginTop: "3px" }}>
          <div className={style.SortArea}>
          <Tooltip title={t("Asc")} color="#CF0000">
                <img
                  src={sorting === "asc" ? AscRed : DescGrey}
                  alt="asc"
                  className={sorting === "asc" ? "w-[10px] cursor-pointer":"rotate-180 w-[10px] cursor-pointer"}
                  onClick={() => {
                    doSort("asc");
                  }}
                />
              </Tooltip>

              <Tooltip title={t("Desc")} color="#CF0000">
                <img
                  src={sorting === "asc" ? DescGrey : AscRed}
                  alt="desc"
                  className={sorting === "asc" ? "w-[10px] cursor-pointer":"rotate-180 w-[10px] cursor-pointer"}
                  onClick={() => {
                    doSort("desc");
                  }}
                  
                />
              </Tooltip>
          </div>
        </div>
      </div>
      ),
      dataIndex: "code",
      key: "code",
      render: (code) => <span>{code}</span>,
    },

    {
      title: (
        <span className="font-roboto text-lg text-[#222222] font-medium">
          {t("Parameter Name")}
        </span>
      ),
      dataIndex: "name",
      key: "name",
      render: (name) => <span>{name}</span>,
    },
    {
      title: (
        <span className="font-roboto text-lg text-[#222222] font-medium">
          {t("Created At")}
        </span>
      ),
      dataIndex: "created_by",
      key: "created_by",
      render: (created_by) => <span>{created_by}</span>,
    },
    {
      title: (
        <span className="font-roboto text-lg text-[#222222] font-medium">
          {t("Modified By")}
        </span>
      ),
      dataIndex: "modified_by",
      key: "modified_by",
      render: (modified_by) => <span>{modified_by}</span>,
    },
    {
      title: (
        <span className="font-roboto text-lg text-[#222222]">
          {t("USER:ACTION_FIELD")}
        </span>
      ),
      dataIndex: "action",
      key: "action",
      render: (action) => action,
    },
  ];

  const handlePagination = (a,b)=>{
    if (a && b) {
      setPage(a)
      setLimit(b)
    } else {
     
    }
  };

  const fetchRecommendation = async (
    page,
    limit,
    filters,
    mapping_principal_id
  ) => {
    if (filters.length >= 1) {
      let res = await doGet(`/grolog-parameter/search?page=1&limit=10&filter=name||code lk ${filters}&${param}`, token);
    setListRecommendation(res?.data?.payload?.data);

    }
  };

  const handleChange = (value, id) => {
    setDepot(id?.id);
    setDepotName(value);
    fetchData();
  };

  const onSearchRecommendation = async (value) => {
    setIsfilter(true)
    setSearchRecommedation(value)
    if (value) {
      setSearchRecommedation(value)
      await fetchRecommendation(1,10,value)
    } else {
    }
  };

  const onSelectRecommendation =(data) => {
    setPage(1)
    setFilter(data)
    fetchData(data, sorting, 1)
    setIsfilter(false);
  };

  const onClearRecommendation = (e) => {
    setLoad(true)
    setIsfilter(false);
    setFilter(null);
    setSearchRecommedation("");
    setListRecommendation([]);
    fetchData("",sorting,1);
    setLoad(false)
  };

  const options =
      listRecommendation &&
      listRecommendation.map((item) => ({
        value: item.value,
        label: item.value,
      }));


  return (
    <>
      <Delete
        data={data.updated_at}
        id={data.id}
        delete={showDelete}
        title={data?.parameter_name}
        url={"grolog-parameter"}
        action={() => setShowDelete(false)}
        route={ROUTES.PARAMETER.LIST}
        // refresh={fetchData()}
      />
      <div className="p-[24px] flex flex-col gap-[24px]">
        <Breadcumbs
          jmlLevel={3}
          menuLevel1={`Setup`}
          menuLevel2={`Profile Configuration`}
          menuLevel3={`System Parameter`}
        />

        <h1 className="font-sans-bold text-2xl" id="title">
          {t("System Parameter")}
        </h1>

        <div
          className={
            style.headerContainer + " flex justify-between items-center"
          }
        >
         <AutoComplete
                 options={options}
                 value={searchRecommendation}
                 onChange={(value) => onSearchRecommendation(value)}
                 onSelect={(value) => onSelectRecommendation(value)}
               >
              <Input
                placeholder={t("Search Parameter Name or Code")}
                className="w-[350px] h-[47px]"
                height={47}
                width={350}
                suffix={<img 
                  src={filter? CloseIconSearch : SearchIcon} 
                  alt="search" 
                  onClick={filter? () => onClearRecommendation() : null}
                />}
                
                value={searchRecommendation}
              />
            </AutoComplete>
        </div>
{
  !load ?
  <div className={style.tableContainer}>
  <CustomTable columns={ListColumn} data={dataSource} />
  <div className={style.containerPagination + " mt-[-45px]"}>
    <CustomPaging
      idLimit="ddlrowsperpagemustselllist"
      idPagination="btnpaginationmustselllist"
      size="small"
      current={page}
      defaultCurrent={page}
      pageSize={limit}
      total={initiate && initiate?.count_data}
      pageSizeOptions={initiate && initiate?.valid_limit}
      onShowSizeChange={() => handlePagination()}
      handlePaging={(a,b) => handlePagination(a,b)}
      title={t("COMMON:ROW_PAGE")}
    />
  </div>
</div>
:
"...loading"
}
       
      </div>
    </>
  );
};

export default SystemParameterList;
